module.exports = __webpack_public_path__ + "img/addi.da8ec6d8.png";